import { ArchiveService} from '@/modules/archive/archive-service';
import Errors from '@/shared/error/errors';
import Message from '@/shared/message/message';
import i18n from '@/shared/plugins/vue-i18n';

// action types
export const DO_CREATE = 'create';
export const DO_UPDATE = 'update';
export const DO_REMOVE = 'remove';

// mutation types

const state = {};

const getters = {};

const mutations = {}

const actions = {
    [DO_CREATE](context, payload) {
        return new Promise((resolve, reject) => {
            context.commit('shared/activateLoading', 'archive/workspacesForm/create', { root: true });
            ArchiveService.createWorkspace(payload)
                .then((data) => {
                    Message.success(i18n.t('GENERAL.CREATED_SUCCESS'));
                    resolve(data);
                })
                .catch(( error ) => {
                    Errors.handle(error);
                    reject();
                })
                .finally(() => {
                    context.commit('shared/deactivateLoading', 'archive/workspacesForm/create', { root: true });
                });
        });
    },
    [DO_REMOVE](context, id) {
        return new Promise((resolve, reject) => {
            context.commit('shared/activateLoading', 'archive/workspacesForm/remove', { root: true });
            ArchiveService.removeWorkspace(id)
                .then(() => {
                    Message.success(i18n.t('GENERAL.REMOVE_SUCCESS'));
                    resolve();
                })
                .catch(( error ) => {
                    Errors.handle(error);
                    reject();
                })
                .finally(() => {
                    context.commit('shared/deactivateLoading', 'archive/workspacesForm/remove', { root: true });
                });
        });
    },
    [DO_UPDATE](context, payload) {
        return new Promise((resolve, reject) => {
            context.commit('shared/activateLoading', 'archive/update', { root: true });
            ArchiveService.updateWorkspace(payload)
                .then(() => {
                    Message.success(i18n.t('GENERAL.UPDATED_SUCCESS'));
                    resolve();
                })
                .catch(( error ) => {
                    Errors.handle(error);
                    reject();
                })
                .finally(() => {
                    context.commit('shared/deactivateLoading', 'archive/workspacesForm/update', { root: true });
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
